export enum OfflineSearchIndexStatus {
    INDEXED = "Indexed",
    INDEXING = "Indexing",
    NOT_INDEXED = "Not Indexed",
}
